// quick: Vista rápida muy resumida solo datos importantes
// brief: Vista sin detalles
// full: Vista completa con detalles expandibles
const TranspaisDepartureViewVariant = {
  quick: 0,
  brief: 1,
  full: 2
}

export default TranspaisDepartureViewVariant